import { render, staticRenderFns } from "./ClientProps.vue?vue&type=template&id=fe04c5fc&"
import script from "./ClientProps.vue?vue&type=script&lang=ts&"
export * from "./ClientProps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports